// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
// import { FormattedMessage } from 'react-intl';

// assets
import { FileDoneOutlined, TeamOutlined } from "@ant-design/icons";
import ChromeOutlined from "@ant-design/icons/ChromeOutlined";
import { Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Quotation } from "utils/asset";

// type

// icons
const icons = { ChromeOutlined, FileDoneOutlined, TeamOutlined };

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const samplePage = {
  id: "tenant",
  title: <FormattedMessage id="tenant" />,
  type: "group",
  url: "/tenant",
  icon: icons.TeamOutlined,
};

export default samplePage;
